// Action Types
export const SUBMIT_FETCH_BENCHMARKING_REQUEST =
  "SUBMIT_FETCH_BENCHMARKING_REQUEST";
export const SUBMIT_FETCH_BENCHMARKING_SUCCESS =
  "SUBMIT_FETCH_BENCHMARKING_SUCCESS";
export const SUBMIT_FETCH_BENCHMARKING_FAILURE =
  "SUBMIT_FETCH_BENCHMARKING_FAILURE";

// Action Creators
export const submitFetchBenchmarkingRequest = (client_company, dimension) => ({
  type: SUBMIT_FETCH_BENCHMARKING_REQUEST,
  payload: { client_company, dimension },
});

export const submitFetchBenchmarkingSuccess = (message) => ({
  type: SUBMIT_FETCH_BENCHMARKING_SUCCESS,
  payload: message,
});

export const submitFetchBenchmarkingFailure = (error) => ({
  type: SUBMIT_FETCH_BENCHMARKING_FAILURE,
  payload: error,
});
